export default "__VITE_ASSET__nI82aPlqQiLHDrEhcIouXQ__"